<script setup lang="ts">
import { toRefs } from 'vue';

export interface ChartLegendItemPropsInterface {
  className?: string;
  title: string;
  total?: string;
  color?: string;
  textColor?: string;
  numberColor?: string;
  percentage?: string;
}
const props = defineProps<ChartLegendItemPropsInterface>();
const { className, title, total, color, textColor, numberColor, percentage } = toRefs(props);

const formatNumber = (value: number) => new Intl.NumberFormat().format(value);
</script>

<template>
  <div class="flex justify-content-between py-1 pl-1 w-full" :class="className" :style="{ color }">
    <div class="flex align-items-center">
      <div :style="{ background: color }" class="mr-2 dot"></div>
      <div class="text-xs" :style="{ color: textColor }">{{ title }}</div>
    </div>
    <div class="flex align-items-center" :style="{ color: numberColor }">
      <div class="font-bold text-sm text-right">{{ formatNumber(total) }}</div>
      <div class="ml-3 text-exm w-2rem text-right">{{ percentage }}%</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.total {
  width: 24px;
}
.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.text-exm {
  font-size: 10px;
}
</style>
